import leapFaviconWhite from '@/assets/leap-favicon-white.png'
import { useRfidDrawerOptional } from '@/contexts/RfidDrawerContext'

export function RfidMenuButton({ onPress }: { onPress?: () => void }) {
  const drawer = useRfidDrawerOptional()
  const handlePress = onPress ?? drawer?.openDrawer

  if (!handlePress) return null

  return (
    <button
      type="button"
      onClick={handlePress}
      className="rfid-app-header__icon-btn rfid-menu-btn"
      aria-label="Open menu"
    >
      <img
        src={leapFaviconWhite}
        alt=""
        className="h-[22px] w-[22px] rounded object-contain"
        draggable={false}
      />
    </button>
  )
}
